/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForOciSaasUserManagedIndividual extends models.StorageConfigurationBaseForOciSaas {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForOciSaasUserManagedIndividual");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForOciSaasUserManagedIndividual.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForOciSaasUserManagedIndividual>): StorageConfigurationForOciSaasUserManagedIndividual {
        let obj = Object.assign(new StorageConfigurationForOciSaasUserManagedIndividual(), model);
        StorageConfigurationForOciSaasUserManagedIndividual.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForOciSaasUserManagedIndividual>): StorageConfigurationForOciSaasUserManagedIndividual {
        if (!model) return null;
        return StorageConfigurationForOciSaasUserManagedIndividual.newInstance(<StorageConfigurationForOciSaasUserManagedIndividual> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForOciSaasUserManagedIndividual) {
        if (!obj) return;

        models.StorageConfigurationForOciSaasUserManagedIndividual.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForOciSaasUserManagedIndividual): boolean {
        if (models.StorageConfigurationBaseForOciSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForOciSaasUserManagedIndividual.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
